import React from 'react';
import '../less/collection.less';
import hero_img from '../img/hero_img.png';
import Hero from '../../../../../auxiliary-components/shared/HeroBlock';
import AdditionalProduct from '../../../../../auxiliary-components/shared/AdditionalProductBlock';
import tariffsData from '../enums/tariffs_data.json';
import additionalCards01 from '../enums/additional_cards_01_data.json';
import additionalCards02Data from '../enums/additional_cards_02_data.json';
import hero_data from '../enums/hero_data.json';
import BusinessOrder from '../../../../BusinessOrder';
import businessTypesItems from '../enums/business_types_items.json';
import safeScheduleItems from '../enums/safe_schedule_items.json';
import TransferTableNew from '../../../../../auxiliary-components/shared/TransfersTableNew';

export default function template() {
    const handlersMap = {
      toggleModal: () => this.toggleModal()
    };

    const heroData = {
      ...hero_data,
      link: {
        ...hero_data.link,
        onClick: handlersMap[hero_data.link.onClick],
      },
    };

    const additionalCards02 = additionalCards02Data.map(item => ({
      ...item,
      onClick: handlersMap[item.onClick]
    }));

    return (
      <div className="collection-module">
        <Hero
          data={heroData}
          img={hero_img}
        />
        <div className="content">
          <div className="business-types">
            <div className="container">
              <h2 className="business-types__title">{this.l10n('COLLECTION_NEW_BUSINESS_TYPES_TITLE')}</h2>
              <div className="business-types__body">
                {businessTypesItems.map((item, index) => (
                  <div key={index} className="business-types__item item-business-types">
                    <div className="item-business-types__title">{this.l10n(item.title)}</div>
                    <div className="item-business-types__text">{this.l10n(item.text)}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="safe-schedule">
            <div className="container">
              <h2 className="safe-schedule__title">{this.l10n('COLLECTION_NEW_SAFE_SCHEDULE_TITLE')}</h2>
              <div className="safe-schedule__body">
                {safeScheduleItems.map((item, index) => (
                  <div key={index} className="safe-schedule__item item-safe-schedule">
                    <div className="item-safe-schedule__title">{this.l10n(item.title)}</div>
                    <div className="item-safe-schedule__text">{this.l10n(item.text)}</div>
                  </div>
              ))}
              </div>
            </div>
          </div>
          <div className="cities-availability">
            <div className="container">
              <div className="cities-availability__body">
                <div className="cities-availability__top">
                  <div className="cities-availability__title">{this.l10n('COLLECTION_NEW_CITIES_AVAILABILITY_TITLE')}</div>
                  <div className="cities-availability__text">{this.l10n('COLLECTION_NEW_CITIES_AVAILABILITY_TEXT_TOP')}</div>
                </div>
                <div className="cities-availability__bottom">
                  <p>{this.l10n('COLLECTION_NEW_CITIES_AVAILABILITY_TEXT_BOTTOM')}</p>
                  <a href={`mailto:${this.l10n('COLLECTION_NEW_CITIES_AVAILABILITY_LINK')}`}>
                    {this.l10n('COLLECTION_NEW_CITIES_AVAILABILITY_LINK')}
                  </a>
                </div>
              </div>
            </div>
          </div>
          <TransferTableNew 
            data={tariffsData} 
            title={"COLLECTION_NEW_TARIFFS_TITLE"}
          />
          <AdditionalProduct
            items={additionalCards01}
            title={'COLLECTION_NEW_ADDITIONAL_PRODUCT_01_TITLE'}
          />
          <AdditionalProduct
            items={additionalCards02}
          />
        </div>
        {this.state.showModal && <BusinessOrder attribute="collection" closeModal={this.toggleModal} />}
      </div>
    );
}
